import {
  Box,
  Button,
  Dialog,
  FormControl,
  Grid,
  InputLabel,
  TextField,
  Typography
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import {
  colorLinkGrey,
  colorPrimary,
  colorTextBlack
} from '../../../config/theme';
import { LocalizationProvider, TimeField } from '@mui/x-date-pickers';
import dayjs from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import {
  addNewQuiz,
  getContentById
} from '../../../redux/reducers/contentSlice';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { LoadingButton } from '@mui/lab';
import SnackBarBox from '../../../components/SnackBarBox';
import { handleError } from '../../../utils/utils';

function AddQuizModal({ open, handleClose, contentId, data, fileDuration }) {
  const [quizTitle, setQuizTitle] = useState('');
  const [quizTime, setQuizTime] = useState(dayjs('2022-04-17T15:00:00'));
  const [flashCardId, setFlashcardId] = useState(null);
  const [isShow, setIsShow] = useState(false);
  const [isShow1, setIsShow1] = useState(false);
  const [isShow2, setIsShow2] = useState(false);

  const { authData } = useSelector(state => state.auth);
  const {
    isAddNewQuizLoading,
    isAddNewQuizSuccess,
    isAddNewQuizFailed,
    contentDetails
  } = useSelector(state => state.content);

  const dispatch = useDispatch();

  const handleTimeChange = (event, newValue) => {
    const updatedTime = dayjs(event);
    if (updatedTime.isValid()) {
      const mergedTime = dayjs(quizTime)
        .hour(updatedTime.hour())
        .minute(updatedTime.minute())
        .second(updatedTime.second());

      setQuizTime(mergedTime);
    }
  };

  const handleAddQuiz = method => {
    let quizTiming = dayjs(quizTime).format('mm:ss');

    if (quizTiming == '00:00') {
      setIsShow2(true);
      setTimeout(() => {
        setIsShow2(false);
      }, 2000);
      return;
    }

    let [tempMin, tempSec] = fileDuration.split(':');
    let totalFileDuration = Number(tempMin) * 60 + Number(tempSec);

    let [tempQuizMin, tempQuizSec] = quizTiming.split(':');
    let totalQuizDuration = Number(tempQuizMin) * 60 + Number(tempQuizSec);

    let quizLength = contentDetails?.flashCard?.length || 0;
    let lastQuizTime =
      contentDetails?.flashCard[quizLength - 1]?.flashcardTime || '00:00';
    let [tempLastQuizMin, tempLastQuizSec] = lastQuizTime.split(':');

    const data = contentDetails?.flashCard || [];

    const timesArray = data?.map(item => item.flashcardTime);

    let totalLastQuizDuration =
      Number(tempLastQuizMin) * 60 + Number(tempLastQuizSec);

    if (method == 'Add' && data?.length > 0) {
      let currentTime = dayjs(quizTime).format('mm:ss');

      if (timesArray.includes(currentTime)) {
        setIsShow1(true);
        setTimeout(() => {
          setIsShow1(false);
        }, 2000);
        return;
      }
    }

    if (totalQuizDuration > totalFileDuration) {
      setIsShow(true);
      setTimeout(() => {
        setIsShow(false);
      }, 2000);
    } else {
      let payload = {
        contentId: contentId || 0,
        flashcardId: method == 'Add' ? null : flashCardId,
        flashcardName: quizTitle || '',
        time: dayjs(quizTime).format('mm:ss') || '',
        loggedInUserName: authData?.userName || ''
        // sequence: method == 'Add' ? quizLength + 1 : 0
      };

      const formData = new FormData();
      formData.append('multipartFileList', null);
      formData.append('flashCard', JSON.stringify(payload));
      dispatch(addNewQuiz(formData));

      setTimeout(() => {
        handleClose();
      }, 800);
    }
  };

  useEffect(() => {
    if (data) {
      setQuizTitle(data?.flashcardName || '');
      setQuizTime(dayjs(`2022-04-17T15:${data?.flashcardTime}`) || '');
      setFlashcardId(data?.flashcardId || '');
    }
  }, [data]);

  return (
    <Dialog
      sx={{
        '& .MuiDialog-paper': {
          borderRadius: '8px'
        }
      }}
      open={open}
      onClose={() => {
        handleClose();
      }}
    >
      <Grid sx={{ padding: '40px', width: '496px' }}>
        <Typography
          fontSize={'20px'}
          color={colorTextBlack}
          fontWeight={'700'}
          mb={0.5}
        >
          {data ? 'Edit Quiz' : 'Add Quiz'}
        </Typography>
        <Typography
          fontSize={'14px'}
          color={colorTextBlack}
          fontWeight={'600'}
          mb={2}
        >
          You can add up to 5 questions under one quiz.
        </Typography>

        <Box>
          <InputLabel
            required
            sx={{
              fontWeight: '700',
              color: colorTextBlack,
              fontSize: '16px',
              mb: 0.6
            }}
          >
            Quiz Title
          </InputLabel>
          <FormControl variant="outlined" fullWidth size="small">
            <TextField
              maxRows={4}
              name="quizTitle"
              placeholder="Enter interesting title for the quiz "
              variant="outlined"
              size="small"
              inputProps={{ maxLength: 200 }}
              value={quizTitle}
              onChange={e => setQuizTitle(e.target.value)}
            />
            <div
              style={{
                display: 'flex',
                justifyContent: 'flex-end'
              }}
            >
              <Typography variant="body2" color="textSecondary">
                {quizTitle ? quizTitle?.length : 0}
                /200
              </Typography>
            </div>
          </FormControl>
        </Box>
        <Box>
          <InputLabel
            required
            sx={{
              fontWeight: '700',
              color: colorTextBlack,
              fontSize: '16px',
              mb: 0.6
            }}
          >
            At a specific time
          </InputLabel>
          <FormControl variant="outlined" fullWidth size="small">
            <Box display={'flex'} alignItems={'center'} gap={1}>
              <Typography
                fontSize={'16px'}
                color={colorLinkGrey}
                fontWeight={'700'}
                marginRight={1}
              >
                Time
              </Typography>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <TimeField
                  value={quizTime}
                  format="mm:ss"
                  size="small"
                  onChange={handleTimeChange}
                  sx={{
                    width: '72px',
                    '& .MuiInputBase-input': {
                      fontSize: '16px',
                      color: colorTextBlack,
                      borderRadius: '8px',
                      borderColor: '#CBD2D9'
                    }
                  }}
                />
              </LocalizationProvider>
            </Box>
          </FormControl>
        </Box>
        <Grid mt={3} item display={'flex'} justifyContent={'start'} gap={2}>
          <Button
            variant="outlined"
            onClick={() => handleClose()}
            sx={{
              px: 4,
              borderColor: colorPrimary,
              borderRadius: '10px',
              color: 'black',
              borderWidth: '2px',
              height: '42px',
              width: '106px',
              '&:hover': {
                borderColor: colorPrimary,
                backgroundColor: 'transparent',
                borderRadius: '10px',
                borderWidth: '2px'
              }
            }}
          >
            Cancel
          </Button>

          <LoadingButton
            variant="contained"
            disabled={!quizTitle || !quizTime}
            sx={{ mr: 2, px: 4, borderWidth: 2, width: '90px' }}
            onClick={() => handleAddQuiz(data ? 'Edit' : 'Add')}
            loading={isAddNewQuizLoading}
          >
            {data ? 'Save' : 'Add'}
          </LoadingButton>
        </Grid>
      </Grid>

      {isShow && (
        <SnackBarBox
          type="error"
          message={handleError('Quiz time must be less than video duration')}
        />
      )}

      {isShow1 && (
        <SnackBarBox
          type="error"
          message={handleError('Quiz time is already present')}
        />
      )}

      {isShow2 && (
        <SnackBarBox
          type="error"
          message={handleError('Quiz time must be greater than 00:00')}
        />
      )}
    </Dialog>
  );
}

export default AddQuizModal;
